'use client';

import { THEME_COLOR_CSS_VARS } from './theme-css';

import type { Theme, ThemeColors } from '@utazzo/shared';

/**
 * Applies theme tokens from AppConfig to the document by setting CSS custom
 * properties on :root. Tailwind picks these up via the shared preset.
 *
 * This is how branding/theme changes ship without a code deploy: update the
 * theme rows in app_config, refresh the page, new theme renders.
 */

const setColorProps = (target: HTMLElement, colors: ThemeColors): void => {
  for (const [key, cssVar] of Object.entries(THEME_COLOR_CSS_VARS) as Array<
    [keyof ThemeColors, string]
  >) {
    target.style.setProperty(cssVar, colors[key]);
  }
};

export const applyTheme = (theme: Theme): void => {
  const root = document.documentElement;

  // Resolve which mode to apply
  const mode =
    theme.defaultMode === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
      : theme.defaultMode;

  root.classList.toggle('dark', mode === 'dark');
  setColorProps(root, theme.colors[mode]);

  root.style.setProperty('--radius', theme.radius);
  root.style.setProperty('--font-sans', theme.fonts.sans);
  root.style.setProperty('--font-heading', theme.fonts.heading);
  root.style.setProperty('--font-mono', theme.fonts.mono);
};
